export default __webpack_public_path__ + "static/media/shift_management.ae884e0c.svg";